/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 16.09.2020
 * Description : Configurations des requêtes API pour les sessions
 * Fichier : sessionService.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/sessions'

export default {
  getSessions() {
    return axios.get(API_URL + CONTROLLER)
  },
  getSession(id) {
    return axios.get(API_URL + `${CONTROLLER}/${id}`)
  },
  postSession(session) {
    return axios.post(API_URL + CONTROLLER, session)
  },
  putSession(session) {
    return axios.put(API_URL + `${CONTROLLER}/${session.sessionId}`, session)
  },
  deleteSession(sessionId) {
    return axios.delete(API_URL + `${CONTROLLER}/${sessionId}`)
  }
}
